<div *ngIf="!loading">
  <div class="spinner"></div>
  <p class="text-center" style="color: #777;margin: -70px 0 100px;">Carregando solicitação, por favor aguarde ...
  </p>
</div>

<div *ngIf="loading" class="animated fadeIn">

  <div *ngIf="atualizar == 1">
    <div class="callout callout-info">
      <h4>Não houveram alterações nesta etapa!</h4>
    </div>

    <div class="timeline-body">

      <h4>
        <span *ngIf="listCronogramaFisicoVigente.length != 0">
          Lista do Cronograma
        </span>
      </h4>

      <div *ngFor="let meta of listCronogramaFisicoVigente; let iterationMeta = index;">
        <div class="box" *ngIf="listCronogramaFisicoVigente.length != 0">
          <div class="box-header">
            <br>
            <br>
            <h3 class="box-title">
              <b>Meta {{ iterationMeta+1 }}:</b> &nbsp; {{ meta.meta }}</h3>
            <p class="help-block">{{ meta.descricaoMeta }}</p>
            <div class="box-tools">
            </div>
          </div>
          <div class="box-body table-responsive no-padding">

            <table class="table">
              <tbody>
                <tr>
                  <th>Especificação</th>
                  <th>Início</th>
                  <th>Término</th>
                </tr>
                <tr *ngFor="let etapa of meta.etapaCronogramaFisico; let iterationEtapa = index;">
                  <td>
                    <b>Etapa {{ iterationMeta+1 }}.{{ iterationEtapa+1 }}:</b> &nbsp; {{ etapa.especificacao
                  }}
                  </td>
                  <td>{{ etapa.dataIni | date: 'dd/MM/yyyy' }}</td>
                  <td>{{ etapa.dataFim | date: 'dd/MM/yyyy' }}</td>
                </tr>
              </tbody>
            </table>



          </div>
        </div>
      </div>


    </div>


    <div class="callout callout-info">
      <h4>Não houveram alterações nesta etapa!</h4>
    </div>
  </div>

  <mat-tab-group *ngIf="atualizar == 0 || atualizar == 2">

    <br>

    <mat-tab label="Cronograma vigente">

      <br>

      <div *ngIf="atualizar == 2" class="callout callout-info">
        <h4>Todas as alterações foram avaliadas!</h4>
      </div>


      <div class="timeline-body">

        <h4>
          <span *ngIf="listCronogramaFisicoVigente.length != 0">
            Lista do Cronograma
          </span>
        </h4>

        <div *ngFor="let meta of listCronogramaFisicoVigente; let iterationMeta = index;">
          <div class="box" *ngIf="listCronogramaFisicoVigente.length != 0">
            <div class="box-header">
              <br>
              <br>
              <h3 class="box-title">
                <b>Meta {{ iterationMeta+1 }}:</b> &nbsp; {{ meta.meta }}</h3>
              <p class="help-block">{{ meta.descricaoMeta }}</p>
              <div class="box-tools">
              </div>
            </div>
            <div class="box-body table-responsive no-padding">

              <table class="table">
                <tbody>
                  <tr>
                    <th>Especificação</th>
                    <th>Início</th>
                    <th>Término</th>
                  </tr>
                  <tr *ngFor="let etapa of meta.etapaCronogramaFisico; let iterationEtapa = index;">
                    <td>
                      <b>Etapa {{ iterationMeta+1 }}.{{ iterationEtapa+1 }}:</b> &nbsp; {{ etapa.especificacao
                        }}
                    </td>
                    <td>{{ etapa.dataIni | date: 'dd/MM/yyyy' }}</td>
                    <td>{{ etapa.dataFim | date: 'dd/MM/yyyy' }}</td>
                  </tr>
                </tbody>
              </table>



            </div>
          </div>
        </div>


      </div>

    </mat-tab>


    <mat-tab label="Cronograma com alterações">
      <br>

      <div *ngIf="atualizar == 2" class="callout callout-info">
        <h4>Todas as alterações foram avaliadas!</h4>
      </div>

      <div class="timeline-body">

        <h4>
          <span *ngIf="listCronogramaFisicoAlterado.length != 0">
            Lista do Cronograma
          </span>
        </h4>

        <div *ngFor="let meta of listCronogramaFisicoAlterado; let iterationMeta = index;">
          <div class="box" *ngIf="listCronogramaFisicoAlterado.length != 0">

            <div class="box-header">
              <br>
              <br>
              <h3 class="box-title">
                <b>Meta {{ iterationMeta+1 }}:</b> &nbsp; {{ meta.meta }}</h3>
              <p class="help-block">{{ meta.descricaoMeta }}</p>
              <div *ngIf="meta.tipoAlteracao != null" class="box-tools">
                <b>Tipo:</b> {{ retornaTipoAlteracao(meta.tipoAlteracao) }} / <b>Status:</b>

                <span *ngIf="retornaStatusAlteracao(meta) == 'Submetida'" style="font-size: 12px;"
                  class="label label-warning">Não avaliada
                </span>
                <span *ngIf="retornaStatusAlteracao(meta) == 'Indefinido'" style="font-size: 12px;"
                  class="label label-warning">Indefinido
                </span>
                <span *ngIf="retornaStatusAlteracao(meta) == 'Reprovada'" style="font-size: 12px;"
                  class="label label-danger">Reprovada
                </span>
                <span *ngIf="retornaStatusAlteracao(meta) == 'Aprovada'" style="font-size: 12px;"
                  class="label label-success">Aprovada
                </span>

                &nbsp;&nbsp;
                <button (click)="openModalAvaliarAlteracaoMeta(meta)" class="btn btn-primary btn-xs  pull-right"
                  style="margin: 3px 0 0 0;">
                  <i class="fa fa-edit"></i>
                  <span *ngIf="retornaStatusAlteracao(meta) == 'Submetida'">Avaliar</span>
                  <span *ngIf="retornaStatusAlteracao(meta) != 'Submetida'">Alterar Av.</span>
                </button>&nbsp;&nbsp;
              </div>
            </div>


            <div class="box-body table-responsive no-padding">

              <table class="table">
                <tbody>
                  <tr>
                    <th>Especificação</th>
                    <th>Início</th>
                    <th>Término</th>
                    <th>Tipo alteração</th>
                    <th>Status</th>
                    <th class="text-center" style="width: 85px;">Ação</th>
                  </tr>
                  <tr *ngFor="let etapa of meta.etapaCronogramaFisico; let iterationEtapa = index;">

                    <td><b>Etapa {{ iterationMeta+1 }}.{{ iterationEtapa+1 }}:</b> &nbsp; {{ etapa.especificacao}}</td>
                    <td>{{ etapa.dataIni | date: 'dd/MM/yyyy' }}</td>
                    <td>{{ etapa.dataFim | date: 'dd/MM/yyyy' }}</td>
                    <td class="text-center"> {{ retornaTipoAlteracao(etapa.tipoAlteracao) }} </td>
                    <td class="text-center">
                      <span *ngIf="retornaStatusAlteracao(etapa) == '-'">-</span>
                      <span *ngIf="retornaStatusAlteracao(etapa) == 'Submetida'" style="font-size: 12px;"
                        class="label label-warning">Não avaliada
                      </span>
                      <span *ngIf="retornaStatusAlteracao(etapa) == 'Reprovada'" style="font-size: 12px;"
                        class="label label-danger">Reprovada
                      </span>
                      <span *ngIf="retornaStatusAlteracao(etapa) == 'Aprovada'" style="font-size: 12px;"
                        class="label label-success">Aprovada
                      </span>

                    </td>

                    <td class="text-center">
                      <button *ngIf="retornaStatusAlteracao(etapa) != '-'"
                        (click)="openModalAvaliarAlteracaoEtapa(etapa)" class="btn btn-primary btn-xs  pull-right"
                        style="margin: 3px 0 0 0;">
                        <i class="fa fa-edit"></i>
                        <span *ngIf="retornaStatusAlteracao(etapa) == 'Submetida'">Avaliar</span>
                        <span *ngIf="retornaStatusAlteracao(etapa) != 'Submetida'">Alterar Av.</span>
                      </button>
                      <span *ngIf="retornaStatusAlteracao(etapa) == '-'">-</span>
                    </td>

                  </tr>
                </tbody>
              </table>



            </div>

          </div>
        </div>


      </div>


    </mat-tab>

  </mat-tab-group>

</div>


<!--MODAIS-->
<p-dialog [style]="{width: '800px', 'min-height': '600px'}" [header]="tituloModalMeta" [(visible)]="modalMetaAlterada"
  showEffect="fade" [modal]="true">

  <mat-tab-group *ngIf="metaAlterada">

    <mat-tab label="Antes">
      <br>
      <mat-card>
        <mat-card-header>
          <mat-card-title><label>{{ avaliarAlteracaoMeta.metaAntes }}</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ avaliarAlteracaoMeta.descricaoMetaAntes }}</p>
        </mat-card-content>
      </mat-card>

      <br>

    </mat-tab>

    <mat-tab label="Depois">

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>{{ avaliarAlteracaoMeta.metaDepois }}</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ avaliarAlteracaoMeta.descricaoMetaDepois }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <div class="callout callout-info">
        <h4>Avaliação da alteração!</h4>

        <form #formAvaliacaoAlteracaoMeta="ngForm" autocomplete="off" (ngSubmit)="avaliarMetaAlterada()">

          <div class="ui-g-12 ui-fluid">
            <div class="form-group">
              <div class="radio">
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios1" (click)="aprovarAvMeta()">Aprovado
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios2" (click)="reprovarAvMeta()">Reprovado
                </label>
              </div>
            </div>

          </div>

          <textarea name="observacao" [(ngModel)]="avaliarAlteracaoMeta.justifAvalAlteracao" class="form-control"
            rows="3" placeholder="Observação ..."></textarea><br>

          <button type="submit" class="btn btn-xs btn-default">AVALIAR</button>

        </form>
      </div>

    </mat-tab>

  </mat-tab-group>

  <mat-tab-group *ngIf="metaAdicionada">

    <mat-tab label="Meta adicionada">

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>{{ avaliarAlteracaoMeta.metaDepois }}</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ avaliarAlteracaoMeta.descricaoMetaDepois }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <div class="callout callout-info">
        <h4>Avaliação da alteração!</h4>

        <form #formAvaliacaoAlteracaoMeta="ngForm" autocomplete="off" (ngSubmit)="avaliarMetaAlterada()">

          <div class="ui-g-12 ui-fluid">
            <div class="form-group">
              <div class="radio">
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios1" (click)="aprovarAvMeta()">Aprovado
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios2" (click)="reprovarAvMeta()">Reprovado
                </label>
              </div>
            </div>

          </div>

          <textarea name="observacao" [(ngModel)]="avaliarAlteracaoMeta.justifAvalAlteracao" class="form-control"
            rows="3" placeholder="Observação ..."></textarea><br>

          <button type="submit" class="btn btn-xs btn-default">Avaliar</button>

        </form>
      </div>

    </mat-tab>

  </mat-tab-group>

  <mat-tab-group *ngIf="metaExcluida">

    <mat-tab label="Meta excluída">

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>{{ avaliarAlteracaoMeta.metaAntes }}</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ avaliarAlteracaoMeta.descricaoMetaAntes }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <div class="callout callout-info">
        <h4>Avaliação da alteração!</h4>

        <form #formAvaliacaoAlteracaoMeta="ngForm" autocomplete="off" (ngSubmit)="avaliarMetaAlterada()">

          <div class="ui-g-12 ui-fluid">
            <div class="form-group">
              <div class="radio">
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios1" (click)="aprovarAvMeta()">Aprovado
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios2" (click)="reprovarAvMeta()">Reprovado
                </label>
              </div>
            </div>

          </div>

          <textarea name="observacao" [(ngModel)]="avaliarAlteracaoMeta.justifAvalAlteracao" class="form-control"
            rows="3" placeholder="Observação ..."></textarea><br>

          <button type="submit" class="btn btn-xs btn-default">Avaliar</button>

        </form>
      </div>

    </mat-tab>

  </mat-tab-group>

</p-dialog>

<p-dialog [style]="{width: '800px', 'min-height': '600px'}" [header]="tituloModalEtapa" [(visible)]="modalEtapaAlterada" showEffect="fade" [modal]="true">

  <mat-tab-group *ngIf="etapaAlterada">

    <mat-tab label="Antes">
      <br>

      <mat-card>

        <h5 style="color: #999;">Especificação:</h5>

        <dl class="dl-horizontal">

          <dd style="margin-left: 0px; padding-left: 0px;">
            <h4 class="text-light-blue" style="margin-top: 0;">
              <b>{{ avaliarAlteracaoEtapa.especificacaoAntes }}</b>
            </h4>
            <h5>
              <b> Início: {{avaliarAlteracaoEtapa.dataIniAntes | date: 'dd MMM. yyyy'}} - Término:
                {{avaliarAlteracaoEtapa.dataFimAntes | date: 'dd MMM. yyyy'}} </b>
            </h5>
            <br>
            <h5 style="color: #999;">Descrição:</h5>
            <h5>
              {{ avaliarAlteracaoEtapa.descricaoAntes }}
            </h5>
          </dd>
        </dl>

      </mat-card>

      <br>

    </mat-tab>

    <mat-tab label="Depois">

      <mat-card>
        <h5 style="color: #999;">Especificação:</h5>

        <dl class="dl-horizontal">

          <dd style="margin-left: 0px; padding-left: 0px;">
            <h4 class="text-light-blue" style="margin-top: 0;">
              <b>{{ avaliarAlteracaoEtapa.especificacaoDepois }}</b>
            </h4>
            <h5>
              <b> Início: {{avaliarAlteracaoEtapa.dataIniDepois | date: 'dd MMM. yyyy'}} - Término:
                {{avaliarAlteracaoEtapa.dataFimDepois | date: 'dd MMM. yyyy'}} </b>
            </h5>
            <br>
            <h5 style="color: #999;">Descrição:</h5>
            <h5>
              {{ avaliarAlteracaoEtapa.descricaoDepois }}
            </h5>
          </dd>
        </dl>
      </mat-card>

      <br>

      <div class="callout callout-info">
        <h4>Avaliação da alteração!</h4>
        <form #formAvaliacaoAlteracao="ngForm" autocomplete="off" (ngSubmit)="avaliarEtapaAlterada()">

          <div class="ui-g-12 ui-fluid">
            <div class="form-group">
              <div class="radio">
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios1" (click)="aprovarAvMeta()">Aprovado
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios2" (click)="reprovarAvMeta()">Reprovado
                </label>
              </div>
            </div>

          </div>

          <textarea name="observacao" [(ngModel)]="avaliarAlteracaoEtapa.justifAvalAlteracao" class="form-control"
            rows="3" placeholder="Observação ..."></textarea><br>

          <button type="submit" class="btn btn-xs btn-default">AVALIAR</button>

        </form>
      </div>

    </mat-tab>

  </mat-tab-group>

  <mat-tab-group *ngIf="etapaAdicionada">

    <mat-tab label="Etapa adicionada">

      <mat-card>
        <h5 style="color: #999;">Especificação:</h5>

        <dl class="dl-horizontal">

          <dd style="margin-left: 0px; padding-left: 0px;">
            <h4 class="text-light-blue" style="margin-top: 0;">
              <b>{{ avaliarAlteracaoEtapa.especificacaoDepois }}</b>
            </h4>
            <h5>
              <b> Início: {{avaliarAlteracaoEtapa.dataIniDepois | date: 'dd MMM. yyyy'}} - Término:
                {{avaliarAlteracaoEtapa.dataFimDepois | date: 'dd MMM. yyyy'}} </b>
            </h5>
            <br>
            <h5 style="color: #999;">Descrição:</h5>
            <h5>
              {{ avaliarAlteracaoEtapa.descricaoDepois }}
            </h5>
          </dd>
        </dl>
      </mat-card>


      <br>

      <div class="callout callout-info">
        <h4>Avaliação da alteração!</h4>

        <form #formAvaliacaoAlteracaoMeta="ngForm" autocomplete="off" (ngSubmit)="avaliarEtapaAlterada()">

          <div class="ui-g-12 ui-fluid">
            <div class="form-group">
              <div class="radio">
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios1" (click)="aprovarAvMeta()">Aprovado
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios2" (click)="reprovarAvMeta()">Reprovado
                </label>
              </div>
            </div>

          </div>

          <textarea name="observacao" [(ngModel)]="avaliarAlteracaoEtapa.justifAvalAlteracao" class="form-control"
            rows="3" placeholder="Observação ..."></textarea><br>

          <button type="submit" class="btn btn-xs btn-default">AVALIAR</button>

        </form>
      </div>

    </mat-tab>

  </mat-tab-group>

  <mat-tab-group *ngIf="etapaExcluida">

    <mat-tab label="Etapa excluída">

      <mat-card>
        <h5 style="color: #999;">Especificação:</h5>

        <dl class="dl-horizontal">

          <dd style="margin-left: 0px; padding-left: 0px;">
            <h4 class="text-light-blue" style="margin-top: 0;">
              <b>{{ avaliarAlteracaoEtapa.especificacaoAntes }}</b>
            </h4>
            <h5>
              <b> Início: {{avaliarAlteracaoEtapa.dataIniAntes | date: 'dd MMM. yyyy'}} - Término:
                {{avaliarAlteracaoEtapa.dataFimAntes | date: 'dd MMM. yyyy'}} </b>
            </h5>
            <br>
            <h5 style="color: #999;">Descrição:</h5>
            <h5>
              {{ avaliarAlteracaoEtapa.descricaoAntes }}
            </h5>
          </dd>
        </dl>
      </mat-card>


      <br>

      <div class="callout callout-info">
        <h4>Avaliação da alteração!</h4>

        <form #formAvaliacaoAlteracaoMeta="ngForm" autocomplete="off" (ngSubmit)="avaliarEtapaAlterada()">

          <div class="ui-g-12 ui-fluid">
            <div class="form-group">
              <div class="radio">
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios1" (click)="aprovarAvMeta()">Aprovado
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios2" (click)="reprovarAvMeta()">Reprovado
                </label>
              </div>
            </div>

          </div>

          <textarea name="observacao" [(ngModel)]="avaliarAlteracaoEtapa.justifAvalAlteracao" class="form-control"
            rows="3" placeholder="Observação ..."></textarea><br>

          <button type="submit" class="btn btn-xs btn-default">AVALIAR</button>

        </form>
      </div>

    </mat-tab>

  </mat-tab-group>

</p-dialog>